export class HssErrorResponse<T> {
  private _body!: T | null;
  private _isSuccess!: boolean;
  private _message!: string;
  private _errorCode!: number;

  get body(): T | null {
    return this._body;
  }

  set body(value: T | null) {
    this._body = value;
  }

  get isSuccess(): boolean {
    return this._isSuccess;
  }

  set isSuccess(value: boolean) {
    this._isSuccess = value;
  }

  get message(): string {
    return this._message;
  }

  set message(value: string) {
    this._message = value;
  }

  get errorCode(): number {
    return this._errorCode;
  }

  set errorCode(value: number) {
    this._errorCode = value;
  }
}
